import { useEffect, useState } from "react";
import { getCourses } from "../api/api";
import { Course } from "../types";
import {
    Box,
    Button,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Pagination,
    Paper,
    Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useAlert } from "../context/AlertContext";

const CourseAccessList = () => {
    const { showAlert } = useAlert();

    const [courses, setCourses] = useState<Course[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const pageSize = 10;

    const fetchCourses = async (uiPage: number) => {
        try {
            setLoading(true);
            const { courses, totalPages } = await getCourses(uiPage - 1, pageSize);
            setCourses(courses);
            setTotalPages(totalPages);
            setPage(uiPage);
        } catch (error: any) {
            showAlert(error?.message ?? "Failed to load courses", "error");
            setCourses([]);
            setTotalPages(1);
            setPage(1);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCourses(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <List sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        {courses.map((course) => (
                            <Paper
                                key={course.id}
                                elevation={1}
                                sx={(theme) => ({
                                    p: 2,
                                    border: `1px solid ${theme.palette.divider}`,
                                    borderRadius: 1,
                                })}
                            >
                                <ListItem sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    <ListItemText
                                        primary={<Typography variant="h6">{course.title}</Typography>}
                                        secondary={course.description}
                                    />

                                    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                                        <Button
                                            component={Link}
                                            to={`/course-access/${course.id}`}
                                            variant="outlined"
                                        >
                                            Assigned Users
                                        </Button>
                                    </Box>
                                </ListItem>
                            </Paper>
                        ))}
                    </List>

                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(_, value) => fetchCourses(value)}
                            color="primary"
                            disabled={loading}
                        />
                    </Box>
                </>
            )}
        </>
    );
};

export default CourseAccessList;
